import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Radio,
  Stack,
  Typography,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { type InstallmentsFormData } from '@/packages/courses/pages/checkout/schema';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';
import { formatMoney } from '@/utils/format-money';

export const CreditCardInstallmentsStep = () => {
  const { values, offer } = useCheckoutWizard();
  const { control } = useFormContext<InstallmentsFormData>();
  const cardNumber = values[CheckoutStepIds.CreditCardDetails]?.number;

  const installments = offer?.checkout_pricing?.installments || [];

  return (
    <Box>
      <Typography variant="h1" color="primary.dark" mb={4}>
        Selecione o parcelamento
      </Typography>

      <Card>
        <CardContent>
          <Typography variant="h3" p={1}>
            Cartão de crédito **** {cardNumber?.slice(-4)}
          </Typography>
        </CardContent>
        <Divider />
        <CardContent>
          <Controller
            name="installments"
            control={control}
            defaultValue={1}
            render={({ field }) => (
              <Stack spacing={2}>
                {installments.map((installment) => {
                  const isSelected = field.value === installment.count;

                  return (
                    <Card key={installment.count} sx={{ border: 'none' }}>
                      <CardActionArea
                        onClick={() => field.onChange(installment.count)}
                        sx={{ py: 1 }}
                      >
                        <Stack direction="row" justifyContent="space-between">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Radio
                              checked={isSelected}
                              value={installment.count}
                              size="small"
                            />
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <Typography variant="body2">
                                {installment.count}x
                              </Typography>
                              <Typography variant="h3">
                                {formatMoney(installment.amount)}
                              </Typography>
                            </Stack>
                          </Stack>
                          <Typography color="success.main">
                            Sem juros
                          </Typography>
                        </Stack>
                      </CardActionArea>
                    </Card>
                  );
                })}
              </Stack>
            )}
          />
        </CardContent>
      </Card>
    </Box>
  );
};
